import Vue from 'vue';
import VueRouter from 'vue-router';
import { startApp } from '@/common/preload/startApp';
import { logout } from '@/common/preload/auth';

import { manageContent } from './middleware/manageContent';
import { checkAvailability } from './middleware/checkAvailability';
import FreeRoutes from './routes/FreeRoutes';
import { freeRoutes } from './helpers/getAppRoutes';

import AllRolesRoutes from './routes/AllRolesRoutes';
import SuperAdminRouter from './routes/SuperAdminRouter';
import PatientRouter from './routes/PatientRouter';
import ClinicAdminRouter from './routes/ClinicAdminRouter';

Vue.use(VueRouter);

export const routes = [].concat(AllRolesRoutes, PatientRouter, SuperAdminRouter, ClinicAdminRouter);

const router = new VueRouter({
  routes: [].concat(FreeRoutes, AllRolesRoutes, PatientRouter, SuperAdminRouter, ClinicAdminRouter),
  mode: 'history',
  saveScrollPosition: false,
});

let appFirstLoad = true;

router.beforeEach(async (to, from, next) => {
  if (to.path === '/sso-auth') {
    await next();
    return;
  }
  if (!location.pathname.includes('invitee')) {
    const isFreeRoute = freeRoutes.some(route => route.name === to.name);
    if (Vue.prototype.$isLoggedNoSession() && !isFreeRoute) {
      if (!Vue.prototype.$getTabSession()) await logout();
      await next({ path: '/login', params: { nextUrl: to.fullPath } });
      return;
    }
  }

  if (appFirstLoad) {
    try {
      appFirstLoad = false;
      await startApp();
    } catch (e) {
      const isFree = !!freeRoutes.find(r => r.name === to.name);
      await next(isFree ? undefined : { name: 'Login' });
      return;
    }
  }
  manageContent(to);

  try {
    checkAvailability(to);
    if (to.meta.middleware) {
      const params = { to, from, ...to.meta };
      if (Array.isArray(to.meta.middleware)) {
        to.meta.middleware.forEach(middleware => middleware(params));
      } else if (typeof to.meta.middleware === 'function') {
        to.meta.middleware(params);
      }
    }
    await next();
  } catch (e) {
    console.dir(e);
    await router.push(e);
  }
});

export default router;
